/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { VisibilityState } from '@tanstack/react-table'

export const getTableVisibilityStorageKey = (tableId: string) => `tableVisibility:${tableId}`

export const readPersistedTableColumnVisibility = (tableId: string): VisibilityState | null => {
    try {
        const raw = localStorage.getItem(getTableVisibilityStorageKey(tableId))
        if (!raw) {
            return null
        }
        return JSON.parse(raw) as VisibilityState
    } catch (error) {
        console.warn('Failed to read table visibility from storage', error)
        return null
    }
}

export const writePersistedTableColumnVisibility = (
    tableId: string,
    visibility: VisibilityState
): void => {
    localStorage.setItem(getTableVisibilityStorageKey(tableId), JSON.stringify(visibility))
}

export const clearPersistedTableColumnVisibility = (tableId: string): void => {
    localStorage.removeItem(getTableVisibilityStorageKey(tableId))
}
